import { ThemeContext } from './ThemeContext';

export const ThemeProvider = ThemeContext.Provider;
